module.exports = __webpack_public_path__ + "static/media/case-when-icon.49ec15ee.svg";